import React, { Component } from 'react';
import { Button, Form, Icon } from 'semantic-ui-react';
import { Editor, EditorState, RichUtils } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import 'draft-js/dist/Draft.css';
import RichEditor from '../Editor/RichEditor';
import FileUpload from './FileUpload';
import {GetData, PostData, PutData} from './../../api/Service';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import RichTextEditor from './../RichText/RichTextEditor';
class EditNews extends Component {
    constructor(props) {
        super(props);
        this.state = {
            category: '',
            headline: '',
            description: '',
            date1: '',
            editorState: '',
            upInfo: [],
            tempInfo: [],
            type: '',
            subtype: '',
            key: '',
            submit: '',
            isLoading: true,
            edit: ''
        };
        
        this.onSubmit = this.onSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.onEditorChange = this.onEditorChange.bind(this);

        window.onbeforeunload = (event) => {
            return 'Changes you have made havent saved. Are you sure?';
        };
    }

    

    componentDidMount() {
        let user = localStorage.getItem('user');
        user = JSON.parse(user);
        let key = user.key;
        let user_id = user._user_.id;
        let url = `api/upload/${key}/api_upload_key/news/${user_id}`;
        GetData(url)
            .then((data) => {
                //console.log(data);
                this.setState({
                    type: data.type,
                    subtype: data.subtype,
                    key: data.key,
                    submit: data.submit
                })
            }

            );

            //set the data
            const data1 = {
                news_id: this.props.data.id,
                id: user_id
            }

            //console.log(this.props.data);
            PostData(`api/news/${key}/edit`, data1)
            .then((resp) => {
                let data = resp.rows[0]
                let d = new Date(data._date_);
                let dd = d.getUTCFullYear() + '-' + this.pad(d.getUTCMonth() + 1) + '-' + this.pad(d.getUTCDate() + 1);
                this.setState({
                    category: resp.category,
                    headline: data.title,
                    description: JSON.parse(data.description)[0],
                    edit: data.message,
                    editorState: data.message,
                    id: data.id,
                    upInfo: JSON.parse(data.uploadInfo),
                    isLoading: false,
                    date1: dd
                })
            })

        
    }

    pad(number) {
        if (number < 10) {
            return '0' + number;
        }
        return number;
    }

    onEditorChange(value){
        this.setState({
            editorState: value
        })
    }

    handleChange(e) {
        var state = {};
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    onNewUpload = (value) => {
        

        let arr = this.state.upInfo.concat(value.files.fileUpload);
        
        arr.map((el) => {
            let name = el.name;
            let ext_1 = name.split('.');
            let ext = ext_1[ext_1.length - 1];
            el['ext'] = ext
        }
        );
        //console.log(arr);
        this.setState({
            upInfo: arr
        });



    }

    onSubmit(e) {
        e.preventDefault();

        let user = localStorage.getItem('user');
        user = JSON.parse(user);
        let key = user.key;
        let user_id = user._user_.id;

        //console.log(stateToHTML(this.state.editorState.getCurrentContent()));
        //short out the data

        const headline = this.state.headline;
        const description = this.state.description;
        const date1 = this.state.date1;
        const upInfo = this.state.upInfo;
        const longd = this.state.editorState;

        const data = {
            ctgy: '1',
            head: headline,
            desc: [description],
            upInfo: upInfo,
            msg: longd,
            cBy: user_id,
            date: date1,
            id: user_id
        }
        

        //var url = `api/insert/${key}/new/${this.state.submit}`;
        var url = `api/news/${key}/edit/${this.state.id}`;
        confirmAlert({
            title: 'Confirm to submit',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this._postData(url,data)
                },
                {
                    label: 'No',
                    onClick: () => window.location.reload()
                }
            ]
        })
        

        
    }

    _postData(url,data){
        PutData(url, data)
            .then((data) => {
                console.log(data)
                if (data.rows.affectedRows === 1) {
                    confirmAlert({
                        title: 'Successfully Submitted',
                        message: 'Your news has been successfully posted',
                        buttons: [
                            {
                                label: 'Okay',
                                onClick: () => this._initialize()
                            }
                        ]
                    })
                }else{
                    confirmAlert({
                        title: 'Something Went Wrong',
                        message: 'Please Contact your administrator',
                        buttons: [
                            {
                                label: 'Okay',
                                onClick: () => this._initialize()
                            }
                        ]
                    })
                }
            });
    }


    _initialize(){
        window.location.reload();
        /* this.setState({
            category: '',
            headline: '',
            description: '',
            date1: '',
            editorState: '',
            upInfo: [],
            tempInfo: []
        }); */
    }

    fileDelete(el,index){
        let arr = this.state.upInfo;
        
        //file delete method call


        arr.splice(index,1);
        this.setState({upInfo: arr});
    }

    


    render() {
        let uploadFiles = [];
        if(this.state.upInfo.length > 0){
            let arr = this.state.upInfo;
            uploadFiles = arr.map((el,index) =>
                <li key={index}>{el.name} <Icon name='delete' color='red' onClick={this.fileDelete.bind(this,el,index)} /></li>
            )
        }
        return (
            <div>
                <Form onSubmit={this.onSubmit}>
                    <Form.Field>
                        <label>Date</label>
                        <input 
                                type="date" 
                                placeholder='Date'
                                name="date1"
                                value={this.state.date1}
                                onChange={this.handleChange}
                                required={true}
                                 />
                    </Form.Field>
                    <Form.Field>
                        <label>Headline</label>
                        <input 
                            name="headline"
                            placeholder='Headline'
                            value={this.state.headline}
                            onChange={this.handleChange}
                            required={true}
                             />
                    </Form.Field>
                    <Form.Field>
                        <label>Short Description (Not more than 50 words)</label>
                        <textarea
                            name="description"
                            placeholder="Short description (Not more than 50 words)"
                            value={this.state.description}
                            onChange={this.handleChange}
                            required={true}
                            rows="5"
                            ></textarea>
                    </Form.Field>

                    <Form.Field>
                        <label>Detailed Description</label>
                        <div>
                            {this.state.isLoading ? null : <RichTextEditor
                                onChange={this.onEditorChange}
                                placeholder="Type Something here"
                                edit={this.state.edit}
                                
                            />}

                            {/* <RichEditor
                                editorState={this.state.editorState}
                                onChange={(editorState) => this.setState({ editorState })}
                                placeholder="You can write HTML here....."
                            /> */}
                        </div>
                        
                    </Form.Field>

                    
                    <br/>
                    <ol className="file-list-show">
                        {uploadFiles}
                    </ol>
                    
                    <hr/>
                    <br/>
                    <Button type='submit'>Submit</Button>
                    
                    
                </Form>


                <FileUpload onChange={this.onNewUpload.bind(this)} type={this.state.type} subtype={this.state.subtype} key_id={this.state.key} submit={this.state.submit} />
            </div>
        )
    }
}

export default EditNews;


// WEBPACK FOOTER //
// ./src/HomeComponents/News/EditNews.js